import React, { useState, useEffect, useRef, useCallback } from "react";
import "../styles/AdminVedapatshala.css";

import {
  COURSE_API,
  COURSE_UPLOAD_API,
  GURUKULAM_API,
  getImageUrl
} from "../config/api";
import { showConfirm } from "../utils/customDialog";

const AdminVedapatshala = () => {
  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [activeTab, setActiveTab] = useState("all-courses");
  
  const [gurukulam, setGurukulam] = useState({
    trust_name: "",
    founder_name: "",
    founder_image: "",
    teacher_name: "",
    teacher_image: ""
  });



  // ================= UNLINK OTHER ADMIN CSS =================
  



  const popupRef = useRef(null);

  // ================= POPUP =================
  const showPopup = useCallback((msg, type = "success") => {
    if (popupRef.current && document.body.contains(popupRef.current)) {
      popupRef.current.remove();
    }

    const div = document.createElement("div");
    popupRef.current = div;

    div.innerHTML = `
      <div style="
        position: fixed;
        top: 20px;
        right: 20px;
        background: ${type === "error" ? "#dc2626" : "#5d1d2b"};
        color: #fff;
        padding: 14px 18px;
        border-radius: 12px;
        z-index: 99999;
        box-shadow: 0 10px 25px rgba(93, 29, 43, 0.25);
        font-size: 14px;
        max-width: 320px;
        font-weight: 600;
        animation: slideIn 0.3s ease;
      ">
        ${msg}
      </div>
      <style>
        @keyframes slideIn {
          from { transform: translateY(-20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      </style>
    `;

    document.body.appendChild(div);

    setTimeout(() => {
      if (div && document.body.contains(div)) {
        div.remove();
      }

      popupRef.current = null;
    }, 2500);
  }, []);

  // ================= FORM STATE =================
  const [newCourse, setNewCourse] = useState({
    title: "",
    sub_title: "",
    date: "",
    main_image: "",
    second_image: "",
    video: "",
    dharma_heading: "",
    dharma_sub: "",
    dharma_body: "",
    aims: [""],
    trust_footer: "",
    founder_name: "",
    founder_image: "",
    teacher_name: "",
    teacher_image: ""
  });
  const [videoUploading, setVideoUploading] = useState(false);

  // ================= FETCH GURUKULAM =================
  const fetchGurukulam = useCallback(async () => {
    try {
      const res = await fetch(GURUKULAM_API);
      const data = await res.json();
      if (data && data.status === "success" && data.data) {
        setGurukulam({
          trust_name: data.data.trust_name || "",
          founder_name: data.data.founder_name || "",
          founder_image: data.data.founder_image || "",
          teacher_name: data.data.teacher_name || "",
          teacher_image: data.data.teacher_image || ""
        });
      }
    } catch (err) {
      console.error("Fetch gurukulam failed:", err);
    }
  }, []);

  // ================= FETCH COURSES =================
  const fetchCourses = useCallback(async () => {
    try {
      const res = await fetch(COURSE_API);;
      const data = await res.json();

      setCourses(data);

      showPopup("Courses loaded successfully");
    } catch (err) {
      console.error("Fetch failed:", err);

      showPopup("Failed to load courses", "error");
    } finally {
      setLoading(false);
    }
  }, [showPopup]);

  useEffect(() => {
    fetchCourses();
    fetchGurukulam();
  }, [fetchCourses, fetchGurukulam]);

  // ================= RESET FORM =================
  const resetForm = () => {
    setEditingId(null);

    setNewCourse({
      title: "",
      sub_title: "",
      date: "",
      main_image: "",
      second_image: "",
      video: "",
      dharma_heading: "",
      dharma_sub: "",
      dharma_body: "",
      aims: [""],
      trust_footer: "",
      founder_name: "",
      founder_image: "",
      teacher_name: "",
      teacher_image: ""
    });

    showPopup("Form reset successfully");
  };

  // ================= SUBMIT FORM =================
  const handleSubmit = async () => {
    const method = editingId ? "PUT" : "POST";

    const payload = editingId
      ? { ...newCourse, id: editingId }
      : newCourse;

    try {
      await fetch(COURSE_API, {
        method,
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      showPopup(
        editingId
          ? "Course updated successfully"
          : "Course added successfully"
      );

      fetchCourses();

      resetForm();
      setActiveTab("all-courses");
    } catch (err) {
      console.error("Submit failed:", err);

      showPopup("Submit failed", "error");
    }
  };

  // ================= SUBMIT GURUKULAM =================
  const handleGurukulamSubmit = async () => {
    try {
      await fetch(GURUKULAM_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(gurukulam)
      });
      showPopup("Gurukulam Staff updated successfully");
      fetchGurukulam();
    } catch (err) {
      console.error("Submit failed:", err);
      showPopup("Submit failed", "error");
    }
  };

  // ================= EDIT COURSE =================
  const handleEdit = (course) => {
    setEditingId(course.id);

    setNewCourse({
      ...course,
      aims: course.aims || [""]
    });

    setActiveTab("course-form");

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    showPopup("Edit mode enabled");
  };

  // ================= DELETE COURSE =================
  const handleDelete = async (id) => {
    const ok = await showConfirm({
      title: "Delete Course",
      message: "Are you sure you want to delete this course?",
      subMessage: "This will permanently remove the course syllabus and details.",
      confirmText: "Delete Course",
      type: "danger"
    });

    if (!ok) return;

    try {
      await fetch(COURSE_API, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ id })
      });

      showPopup("Course deleted successfully");

      fetchCourses();
    } catch (err) {
      console.error("Delete failed:", err);

      showPopup("Delete failed", "error");
    }
  };

  // ================= AIMS =================
  const handleAimChange = (index, value) => {
    const updatedAims = [...newCourse.aims];

    updatedAims[index] = value;

    setNewCourse({
      ...newCourse,
      aims: updatedAims
    });
  };

  const addAim = () => {
    setNewCourse({
      ...newCourse,
      aims: [...newCourse.aims, ""]
    });
  };

  const removeAim = (index) => {
    const updatedAims = newCourse.aims.filter(
      (_, i) => i !== index
    );

    setNewCourse({
      ...newCourse,
      aims: updatedAims
    });
  };

  // ================= FILE UPLOAD =================
  const handleFileUpload = async (e, type) => {
    const file = e.target.files[0];

    if (!file) return;

    const formData = new FormData();

    formData.append("file", file);

    try {
      if (type === "video") setVideoUploading(true);

      const res = await fetch(COURSE_UPLOAD_API, {
        method: "POST",
        body: formData
      });

      let data;
      try {
        data = await res.json();
      } catch (parseErr) {
        throw new Error(`Upload failed (HTTP ${res.status}): Unable to parse server response`);
      }

      if (data.status === "success") {
        if (type === "main") {
          setNewCourse((prev) => ({
            ...prev,
            main_image: data.url
          }));
        }

        if (type === "second") {
          setNewCourse((prev) => ({
            ...prev,
            second_image: data.url
          }));
        }

        if (type === "video") {
          setNewCourse((prev) => ({
            ...prev,
            video: data.url
          }));
        }

        if (type === "founder") {
          setGurukulam((prev) => ({
            ...prev,
            founder_image: data.url
          }));
        }

        if (type === "teacher") {
          setGurukulam((prev) => ({
            ...prev,
            teacher_image: data.url
          }));
        }

        showPopup("File uploaded successfully");
      } else {
        showPopup(data.message || "Upload failed", "error");
      }
    } catch (err) {
      console.error("Upload error:", err);

      showPopup(err.message || "Upload error", "error");
    } finally {
      if (type === "video") setVideoUploading(false);
    }
  };

  // ================= LOADING =================
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "100px", color: "#64748b" }}>
        <div className="spinner-border text-primary" role="status" style={{ color: "#5d1d2b" }}></div>
        <p style={{ marginTop: "15px" }}>Loading Courses...</p>
      </div>
    );
  }

  return (
    <div className="admin-container vedapatshala-admin-container">

      {/* Header with Dashboard Metrics */}
      <div className="vedapatshala-header">
        <div className="header-title-area">
          <h1>
            <i className="bi bi-mortarboard-fill"></i> VedaPatashala Manager
          </h1>
          <p>Manage VedaPatashala courses, aims, footer, and staff leadership</p>
        </div>

        <div className="vedapatshala-metrics-grid">
          <div className="metric-card" onClick={() => setActiveTab("all-courses")} style={{ cursor: "pointer" }}>
            <div className="metric-icon courses"><i className="bi bi-mortarboard"></i></div>
            <div className="metric-info">
              <span className="metric-value">{courses.length}</span>
              <span className="metric-label">Total Courses</span>
            </div>
          </div>
          <div className="metric-card" onClick={() => setActiveTab("staff")} style={{ cursor: "pointer" }}>
            <div className="metric-icon staff"><i className="bi bi-people"></i></div>
            <div className="metric-info">
              <span className="metric-value">{(gurukulam.founder_name ? 1 : 0) + (gurukulam.teacher_name ? 1 : 0)}</span>
              <span className="metric-label">Active Staff</span>
            </div>
          </div>
        </div>
      </div>

      {/* PAGE TABS NAVIGATION */}
      <div className="vedapatshala-tabs">
        <button
          type="button"
          className={`veda-tab-btn ${activeTab === "all-courses" ? "active" : ""}`}
          onClick={() => setActiveTab("all-courses")}
        >
          <i className="bi bi-grid-3x3-gap"></i>
          <span className="tab-text-container">
            <strong>Courses Catalog</strong>
            <span className="tab-subtext">View and manage courses</span>
          </span>
          <span className="badge-count">{courses.length}</span>
        </button>

        <button
          type="button"
          className={`veda-tab-btn ${activeTab === "course-form" ? "active" : ""}`}
          onClick={() => setActiveTab("course-form")}
        >
          <i className="bi bi-plus-circle"></i>
          <span className="tab-text-container">
            <strong>{editingId ? "Edit Course" : "Add New Course"}</strong>
            <span className="tab-subtext">{editingId ? "Update course details" : "Publish new course"}</span>
          </span>
        </button>

        <button
          type="button"
          className={`veda-tab-btn ${activeTab === "staff" ? "active" : ""}`}
          onClick={() => setActiveTab("staff")}
        >
          <i className="bi bi-people"></i>
          <span className="tab-text-container">
            <strong>Staff Details</strong>
            <span className="tab-subtext">Leadership & Teachers</span>
          </span>
        </button>

      </div>

      {/* ================= CONDITIONAL SECTIONS ================= */}
      {activeTab === "course-form" && (
        <section className="admin-form" id="course-form-section">

          {/* ================= FORM HEADER ================= */}
          <div className="section-heading">
            <h2>
              <i className="bi bi-journal-plus"></i> {editingId ? "Update Course" : "Add New Course"}
            </h2>

            <p>
              Create and manage VedaPatashala course content.
            </p>
          </div>

          {/* ================= BASIC INFO ================= */}
          <div className="form-group-card">
            <div className="group-heading">
              <h3>Basic Information</h3>

              <span>
                Enter course title, subtitle, and date.
              </span>
            </div>

            <div className="form-grid-2-1col">
              <div className="form-group">
                <label>Course Title *</label>
                <input
                  type="text"
                  placeholder="Course Title"
                  value={newCourse.title}
                  onChange={(e) =>
                    setNewCourse({
                      ...newCourse,
                      title: e.target.value
                    })
                  }
                />
              </div>

              <div className="form-group">
                <label>Course Date *</label>
                <input
                  type="text"
                  placeholder="Course Date"
                  value={newCourse.date}
                  onChange={(e) =>
                    setNewCourse({
                      ...newCourse,
                      date: e.target.value
                    })
                  }
                />
              </div>
            </div>

            <div className="form-group">
              <label>Course Subtitle *</label>
              <input
                type="text"
                placeholder="Course Subtitle"
                value={newCourse.sub_title}
                onChange={(e) =>
                  setNewCourse({
                    ...newCourse,
                    sub_title: e.target.value
                  })
                }
              />
            </div>
          </div>

          {/* ================= IMAGE SECTION ================= */}
          <div className="form-group-card">
            <div className="group-heading">
              <h3>Course Images</h3>

              <span>
                Upload course preview images.
              </span>
            </div>

            <div className="form-grid-2col">
              <div className="image-upload-wrapper">
                <label>Main Image</label>

                <div className="upload-dropzone">
                  <i className="bi bi-cloud-arrow-up"></i>
                  <p>Click to select and upload main image</p>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      handleFileUpload(e, "main")
                    }
                  />
                </div>

                {newCourse.main_image && (
                  <div className="upload-preview-wrapper">
                    <img
                      src={getImageUrl(newCourse.main_image)}
                      alt="Main"
                      className="upload-preview-img"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='120'%3E%3Crect width='200' height='120' fill='%23fee2e2'/%3E%3Ctext x='100' y='55' font-size='24' text-anchor='middle'%3E⚠️%3C/text%3E%3Ctext x='100' y='85' font-size='11' fill='%23dc2626' text-anchor='middle'%3EImage Failed to Load%3C/text%3E%3C/svg%3E";
                      }}
                    />
                    <div className="upload-preview-info">
                      Main cover image uploaded!
                    </div>
                    <button
                      type="button"
                      onClick={() => setNewCourse((prev) => ({ ...prev, main_image: "" }))}
                      style={{
                        marginTop: "8px",
                        background: "#b00020",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        padding: "5px 14px",
                        fontSize: "13px",
                        cursor: "pointer",
                        fontWeight: "600"
                      }}
                    >
                      ✕ Remove Main Image
                    </button>
                  </div>
                )}
              </div>

              <div className="image-upload-wrapper">
                <label>Second Image</label>

                <div className="upload-dropzone">
                  <i className="bi bi-cloud-arrow-up"></i>
                  <p>Click to select and upload second image</p>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      handleFileUpload(e, "second")
                    }
                  />
                </div>

                {newCourse.second_image && (
                  <div className="upload-preview-wrapper">
                    <img
                      src={getImageUrl(newCourse.second_image)}
                      alt="Second"
                      className="upload-preview-img"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='120'%3E%3Crect width='200' height='120' fill='%23fee2e2'/%3E%3Ctext x='100' y='55' font-size='24' text-anchor='middle'%3E⚠️%3C/text%3E%3Ctext x='100' y='85' font-size='11' fill='%23dc2626' text-anchor='middle'%3EImage Failed to Load%3C/text%3E%3C/svg%3E";
                      }}
                    />
                    <div className="upload-preview-info">
                      Second cover image uploaded!
                    </div>
                    <button
                      type="button"
                      onClick={() => setNewCourse((prev) => ({ ...prev, second_image: "" }))}
                      style={{
                        marginTop: "8px",
                        background: "#b00020",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        padding: "5px 14px",
                        fontSize: "13px",
                        cursor: "pointer",
                        fontWeight: "600"
                      }}
                    >
                      ✕ Remove Second Image
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* ================= VIDEO SECTION ================= */}
          <div className="form-group-card">
            <div className="group-heading">
              <h3>Course Video</h3>

              <span>
                Upload course introduction video (supports MP4, MOV, WEBM, MKV, AVI up to 500MB).
              </span>
            </div>

            <div className="upload-dropzone" style={{ position: "relative" }}>
              {videoUploading ? (
                <div style={{ padding: "16px 0", textAlign: "center" }}>
                  <div className="spinner-border text-maroon" role="status" style={{ color: "#5d1d2b" }}></div>
                  <p style={{ marginTop: "10px", fontWeight: "600", color: "#5d1d2b", fontSize: "14px" }}>
                    Uploading video... Please wait while the file transfers.
                  </p>
                </div>
              ) : (
                <>
                  <i className="bi bi-camera-video"></i>
                  <p>{newCourse.video ? "Change Selected Video" : "Click to select and upload introduction video (up to 500MB)"}</p>
                  <input
                    type="file"
                    accept="video/*,.mp4,.mov,.webm,.mkv,.avi,.m4v"
                    onChange={(e) =>
                      handleFileUpload(e, "video")
                    }
                  />
                </>
              )}
            </div>

            {newCourse.video && (
              <div className="video-preview-wrapper" style={{ marginTop: "15px", display: "flex", flexDirection: "column", gap: "10px" }}>
                <video
                  src={getImageUrl(newCourse.video)}
                  controls
                  className="preview-video"
                  style={{ width: "100%", maxHeight: "240px", borderRadius: "12px", border: "1px solid #cbd5e1" }}
                />
                <button
                  type="button"
                  onClick={() => setNewCourse((prev) => ({ ...prev, video: "" }))}
                  style={{
                    alignSelf: "flex-start",
                    background: "#fee2e2",
                    color: "#dc2626",
                    border: "1px solid #fca5a5",
                    borderRadius: "6px",
                    padding: "6px 14px",
                    fontSize: "12.5px",
                    cursor: "pointer",
                    fontWeight: "600"
                  }}
                >
                  ✕ Remove Video
                </button>
              </div>
            )}
          </div>

          {/* ================= DHARMA SECTION ================= */}
          <div className="form-group-card">
            <div className="group-heading">
              <h3>Dharma Section</h3>

              <span>
                Add dharma heading, subheading, and body.
              </span>
            </div>

            <div className="form-grid-2col">
              <div className="form-group">
                <label>Dharma Heading</label>
                <input
                  type="text"
                  placeholder="Dharma Heading"
                  value={newCourse.dharma_heading}
                  onChange={(e) =>
                    setNewCourse({
                      ...newCourse,
                      dharma_heading: e.target.value
                    })
                  }
                />
              </div>

              <div className="form-group">
                <label>Dharma Subheading</label>
                <input
                  type="text"
                  placeholder="Dharma Subheading"
                  value={newCourse.dharma_sub}
                  onChange={(e) =>
                    setNewCourse({
                      ...newCourse,
                      dharma_sub: e.target.value
                    })
                  }
                />
              </div>
            </div>

            <div className="form-group">
              <label>Dharma Body</label>
              <textarea
                placeholder="Dharma Body"
                value={newCourse.dharma_body}
                onChange={(e) =>
                  setNewCourse({
                    ...newCourse,
                    dharma_body: e.target.value
                  })
                }
              />
            </div>
          </div>

          {/* ================= AIMS SECTION ================= */}
          <div className="form-group-card">
            <div className="group-heading">
              <h3>Aims & Objectives</h3>

              <span>
                Add multiple course objectives.
              </span>
            </div>

            {newCourse.aims.map((aim, index) => (
              <div
                key={index}
                className="aim-input-row"
                style={{ display: "flex", gap: "10px", marginBottom: "12px", alignItems: "center" }}
              >
                <input
                  type="text"
                  placeholder={`Aim ${index + 1}`}
                  value={aim}
                  onChange={(e) =>
                    handleAimChange(
                      index,
                      e.target.value
                    )
                  }
                  style={{ flexGrow: 1 }}
                />

                <button
                  type="button"
                  className="btn-delete-aim"
                  onClick={() =>
                    removeAim(index)
                  }
                >
                  ✕
                </button>
              </div>
            ))}

            <button type="button" className="btn-add-aim" onClick={addAim}>
              <i className="bi bi-plus-lg"></i> Add New Aim
            </button>
          </div>

          {/* ================= FOOTER SECTION ================= */}
          <div className="form-group-card">
            <div className="group-heading">
              <h3>Trust Footer</h3>

              <span>
                Footer content displayed below course.
              </span>
            </div>

            <div className="form-group">
              <label>Trust Footer Text</label>
              <input
                type="text"
                placeholder="Trust Footer"
                value={newCourse.trust_footer}
                onChange={(e) =>
                  setNewCourse({
                    ...newCourse,
                    trust_footer: e.target.value
                  })
                }
              />
            </div>
          </div>

          {/* ================= ACTION BUTTONS ================= */}
          <div className="form-buttons-row">
            <button className="btn-premium" onClick={handleSubmit}>
              <i className="bi bi-cloud-arrow-up"></i> {editingId ? "Update Course" : "Add Course"}
            </button>

            <button className="btn-premium-outline" onClick={resetForm}>
              <i className="bi bi-arrow-counterclockwise"></i> Reset Form
            </button>
          </div>
        </section>
      )}

      {activeTab === "all-courses" && (
        <section id="all-courses-section">

          <div className="section-heading">
            <h2>
              <i className="bi bi-journals"></i> All Courses
            </h2>

            <p>
              View, edit, and manage all VedaPatashala courses.
            </p>
          </div>

          <div className="admin-list-grid">
            {courses.length === 0 ? (
              <div className="no-courses-placeholder">
                <i className="bi bi-journal-x"></i>
                <h3>No courses found</h3>
                <p>Get started by adding a new course using the form tab.</p>
              </div>
            ) : (
              courses.map((course) => (
                <div
                  key={course.id}
                  className="admin-card course-card"
                >
                  {/* IMAGE */}
                  <div className="course-card-image-wrapper">
                    <img
                      src={getImageUrl(course.main_image || course.second_image)}
                      alt={course.title}
                      className="card-image"
                      onError={(e) => {
                        e.target.onerror = null;
                        if (course.second_image && e.target.src !== getImageUrl(course.second_image)) {
                          e.target.src = getImageUrl(course.second_image);
                          return;
                        }
                        e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='360' height='200'%3E%3Crect width='360' height='200' fill='%23f1f5f9'/%3E%3Ctext x='180' y='90' font-size='40' text-anchor='middle'%3E📚%3C/text%3E%3Ctext x='180' y='130' font-size='13' fill='%2394a3b8' text-anchor='middle'%3ENo Course Image%3C/text%3E%3C/svg%3E";
                      }}
                    />
                  </div>

                  {/* CONTENT */}
                  <div className="card-content">
                    <h3>{course.title}</h3>

                    <p className="subtitle">{course.sub_title}</p>

                    <div className="course-detail-row">
                      <span className="detail-label">
                        <i className="bi bi-calendar3"></i> Date:
                      </span>
                      <span className="detail-value">{course.date}</span>
                    </div>

                    <div className="course-detail-row">
                      <span className="detail-label">
                        <i className="bi bi-book"></i> Dharma:
                      </span>
                      <span className="detail-value">{course.dharma_heading}</span>
                    </div>

                    {course.aims && course.aims.length > 0 && (
                      <div className="course-aims-badges">
                        {course.aims.map((aim, idx) => aim.trim() && (
                          <span key={idx} className="aim-badge">
                            {aim}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* ACTIONS */}
                  <div className="card-actions">
                    <button
                      className="btn-edit-course"
                      onClick={() =>
                        handleEdit(course)
                      }
                    >
                      <i className="bi bi-pencil"></i> Edit
                    </button>

                    <button
                      className="btn-delete-course"
                      onClick={() =>
                        handleDelete(course.id)
                      }
                    >
                      <i className="bi bi-trash3"></i> Delete
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </section>
      )}

      {activeTab === "staff" && (
        <section className="admin-form" id="staff-section">
          <div className="section-heading">
            <h2>
              <i className="bi bi-people-fill"></i> Trust Leadership & Gurukulam Staff
            </h2>
            <p>
              Enter global founder and teacher names and upload their pictures. This will be displayed on the VedaPatashala page under the Trust footer.
            </p>
          </div>

          <div className="form-group-card" style={{ padding: "32px" }}>
            <div className="form-grid-2col">
              
              {/* Founder Details Biographical Card */}
              <div style={{ background: "#ffffff", border: "1px solid rgba(226, 232, 240, 0.8)", borderRadius: "16px", padding: "24px" }}>
                <h4 className="staff-group-title" style={{ marginTop: 0 }}>Founder Details</h4>
                <div className="biographical-card-layout">
                  <div className="biographical-photo-box">
                    <span className="biographical-photo-label">Founder Photo</span>
                    {gurukulam.founder_image ? (
                      <div style={{ position: "relative" }}>
                        <img
                          src={getImageUrl(gurukulam.founder_image)}
                          alt="Founder"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect width='100' height='100' fill='%23f1f5f9'/%3E%3Ctext x='50' y='55' font-size='24' text-anchor='middle'%3E👤%3C/text%3E%3C/svg%3E";
                          }}
                        />
                        <button
                          type="button"
                          onClick={() =>
                            setGurukulam({
                              ...gurukulam,
                              founder_image: ""
                            })
                          }
                          className="btn-delete-aim"
                          style={{ position: "absolute", top: "4px", right: "4px", width: "26px", height: "26px" }}
                        >
                          ✕
                        </button>
                      </div>
                    ) : (
                      <div className="upload-dropzone" style={{ minHeight: "120px", marginBottom: 0 }}>
                        <i className="bi bi-cloud-arrow-up"></i>
                        <p>Upload Photo</p>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            handleFileUpload(e, "founder")
                          }
                        />
                      </div>
                    )}
                  </div>

                  <div style={{ flex: 1 }}>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label>Founder Name</label>
                      <input
                        type="text"
                        placeholder="Founder Name"
                        value={gurukulam.founder_name || ""}
                        onChange={(e) =>
                          setGurukulam({
                            ...gurukulam,
                            founder_name: e.target.value
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Teacher Details Biographical Card */}
              <div style={{ background: "#ffffff", border: "1px solid rgba(226, 232, 240, 0.8)", borderRadius: "16px", padding: "24px" }}>
                <h4 className="staff-group-title" style={{ marginTop: 0 }}>Teacher Details</h4>
                <div className="biographical-card-layout">
                  <div className="biographical-photo-box">
                    <span className="biographical-photo-label">Teacher Photo</span>
                    {gurukulam.teacher_image ? (
                      <div style={{ position: "relative" }}>
                        <img
                          src={getImageUrl(gurukulam.teacher_image)}
                          alt="Teacher"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect width='100' height='100' fill='%23f1f5f9'/%3E%3Ctext x='50' y='55' font-size='24' text-anchor='middle'%3E👤%3C/text%3E%3C/svg%3E";
                          }}
                        />
                        <button
                          type="button"
                          onClick={() =>
                            setGurukulam({
                              ...gurukulam,
                              teacher_image: ""
                            })
                          }
                          className="btn-delete-aim"
                          style={{ position: "absolute", top: "4px", right: "4px", width: "26px", height: "26px" }}
                        >
                          ✕
                        </button>
                      </div>
                    ) : (
                      <div className="upload-dropzone" style={{ minHeight: "120px", marginBottom: 0 }}>
                        <i className="bi bi-cloud-arrow-up"></i>
                        <p>Upload Photo</p>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            handleFileUpload(e, "teacher")
                          }
                        />
                      </div>
                    )}
                  </div>

                  <div style={{ flex: 1 }}>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label>Teacher Name</label>
                      <input
                        type="text"
                        placeholder="Teacher Name"
                        value={gurukulam.teacher_name || ""}
                        onChange={(e) =>
                          setGurukulam({
                            ...gurukulam,
                            teacher_name: e.target.value
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className="form-buttons-row">
            <button className="btn-premium" onClick={handleGurukulamSubmit}>
              <i className="bi bi-cloud-arrow-up"></i> Save Staff Details
            </button>
          </div>
        </section>
      )}

    </div>
  );
};

export default AdminVedapatshala;
